export default "__VITE_ASSET__BAOS5HFP__"